import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Box, Link, Typography } from "@mui/joy";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React from "react";
import { useNavigate } from "react-router-dom";
import PortalTableLayout from "../components/PortalTableLayout";

export default function BrokenElevators() {
	const [dataset, setDataset] = React.useState([] as Array<any>);
	const [fromDate, setFromDate] = React.useState(new Date(new Date().setDate(new Date().getDate() - 90)));
	const [toDate, setToDate] = React.useState(new Date());
	const [loading, setLoading] = React.useState(true);

	const n = useNavigate();

	React.useEffect(() => getData(fromDate, toDate), []);

	const getData = (ft: Date, td: Date) => {
		setLoading(true);
		fetch("Building/GetBrokenElevators", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ FromDate: ft, ToDate: td }),
		})
			.then((x) => x.json())
			.then((x) => {
				setDataset(x);
				setLoading(false);
			});
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<PortalTableLayout
				fillHeight={true}
				toolbar={
					<Box
						sx={{
							display: "flex",
							flexWrap: "wrap",
							alignItems: "center",
							justifyContent: "space-between",
							gap: 1.5,
							backgroundColor: "background.surface",
							border: "1px solid",
							borderColor: "divider",
							p: 1.5,
						}}>
						<Typography level="title-lg" sx={{ m: 0 }}>
							Broken Elevators
						</Typography>
						<Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
							<DatePicker
								slotProps={{
									textField: { variant: "standard", size: "small" },
								}}
								label="From Date"
								value={fromDate}
								format="MM/dd/yyyy"
								onChange={(value) => {
									setFromDate(value as Date);
									getData(value as Date, toDate);
								}}
							/>
							<DatePicker
								slotProps={{
									textField: { variant: "standard", size: "small" },
								}}
								label="To Date"
								value={toDate}
								format="MM/dd/yyyy"
								onChange={(value) => {
									setToDate(value as Date);
									getData(fromDate, value as Date);
								}}
							/>
						</Box>
					</Box>
				}>
				<Table stickyHeader size="small">
					<TableHead>
						<TableRow>
							<TableCell>Building</TableCell>
							<TableCell>Serial Number</TableCell>
							<TableCell>Callback Count</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{loading && (
							<TableRow>
								<TableCell colSpan={3} align="center" sx={{ py: 3 }}>
									<CircularProgress size={32} />
								</TableCell>
							</TableRow>
						)}
						{!loading &&
							dataset.map((x) => (
								<TableRow key={x.elevators_id ?? `${x.buildings_id}-${x.serial_number}`}>
									<TableCell>
										<Link
											onClick={() => {
												n("/buildingportal/" + x.buildings_id);
											}}>
											{x.building_name}
										</Link>
									</TableCell>
									<TableCell>{x.serial_number}</TableCell>
									<TableCell>{x.callbacks}</TableCell>
								</TableRow>
							))}
					</TableBody>
				</Table>
			</PortalTableLayout>
		</LocalizationProvider>
	);
}
